import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { Observable } from "rxjs";

import {
    AGEC_DANGEROUS_SUBSTANCE_DESCRIPTION,
    FeatureFlagFacade,
} from "@hermes/states/flipper";

@Component({
    selector: "h-agec-dangerous-substances",
    templateUrl: "./agec-dangerous-substances.component.html",
    styleUrls: ["./agec-dangerous-substances.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgecDangerousSubstancesComponent {
    @Input()
    public isPackaging: boolean = false;

    public hasVal05Description: boolean = false;

    public isDescriptionDisplay$: Observable<boolean> =
        this.featureFlagFacade.isActivated(
            AGEC_DANGEROUS_SUBSTANCE_DESCRIPTION,
        );
    private inputCodesDangerousSubstances: string[] = [];

    constructor(private featureFlagFacade: FeatureFlagFacade) {}

    @Input()
    public get codesDangerousSubstances(): string[] {
        return this.inputCodesDangerousSubstances;
    }

    public set codesDangerousSubstances(codesDangerousSubstances: string[]) {
        this.inputCodesDangerousSubstances = codesDangerousSubstances;
        if (codesDangerousSubstances.includes("VAL_05")) {
            this.hasVal05Description = Boolean(
                $localize`:@@hermes.environment.dangeroussubstances.val05.description:`,
            );
        }
    }
}
